import { render, staticRenderFns } from "./FormCriteria.vue?vue&type=template&id=e81894fc&"
import script from "./FormCriteria.vue?vue&type=script&lang=js&"
export * from "./FormCriteria.vue?vue&type=script&lang=js&"
import style0 from "./FormCriteria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports